<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      scrollable
      dark
      content-class="tutorial-detail-modal"
      transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <v-btn icon plain dark :ripple="false" class="close" @click="close">
          <i class="cu-icon-close"></i>
        </v-btn>
        <v-carousel v-model="model"
                    :hide-delimiters="tutorialItem[select].length === 1"
                    hide-delimiter-background
                    height="50"
                    :show-arrows="false"
                    :continuous="false"
        >
          <v-carousel-item v-for="(item,i) in tutorialItem[select]" :key="i"/>
        </v-carousel>
      </v-card-title>
      <v-card-text>
        <v-carousel v-model="model"
                    hide-delimiters
                    hide-delimiter-background
                    height="100%"
                    :show-arrows="false"
                    :continuous="false"
        >
          <v-carousel-item
              v-for="(item,i) in tutorialItem[select]"
              :key="i"
              :src="getImage(tutorialItem[select][i])"
              contain
          >
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
    </v-card>
    <!--    <template v-if="tutorialItem[select].length === (model+1)">-->
<!--    <v-btn icon plain :ripple="false" @click="close" class="btn-close">-->
<!--      <CloseWhite/>-->
<!--    </v-btn>-->
    <!--    </template>-->

  </v-dialog>
</template>
<script>
import { mixinAuth } from '@/mixins'
// import CloseWhite from '@/components/icons/CloseWhite';

export default {
  components: {
    // CloseWhite,
  },
  mixins: [mixinAuth],
  props: {
    dialog: Boolean,
    select: Number,
  },
  data: () => ({
    model: 0
  }),
  computed: {
    tutorialItem () {
      if (this.isSamsungFire) {
        return [
          ['tutorial/samsungfire/tutorial_main_01.png', 'tutorial/samsungfire/tutorial_main_02.png', 'tutorial/samsungfire/tutorial_main_03.png', 'tutorial/samsungfire/tutorial_main_04.png', 'tutorial/samsungfire/tutorial_main_05.png'],
          ['tutorial/samsungfire/tutorial_library_01.png'],
          ['tutorial/samsungfire/tutorial_square_01.png'],
          ['tutorial/samsungfire/tutorial_suitcase_01.png', 'tutorial/samsungfire/tutorial_suitcase_02.png'],
          ['tutorial/samsungfire/tutorial_mindWeather_01.png'],
          ['tutorial/samsungfire/tutorial_mindNote_01.png', 'tutorial/samsungfire/tutorial_mindNote_02.png'],
          ['tutorial/samsungfire/tutorial_guideChat_01.png', 'tutorial/samsungfire/tutorial_guideChat_02.png', 'tutorial/samsungfire/tutorial_guideChat_03.png', 'tutorial/samsungfire/tutorial_guideChat_04.png'],
        ]
      }
      return [
        ['tutorial/tutorial_main_01.jpg', 'tutorial/tutorial_main_02.jpg', 'tutorial/tutorial_main_03.jpg', 'tutorial/tutorial_main_04.jpg', 'tutorial/tutorial_main_05.jpg'],
        ['tutorial/tutorial_library_01.jpg'],
        ['tutorial/tutorial_square_01.jpg'],
        ['tutorial/tutorial_suitcase_01.jpg', 'tutorial/tutorial_suitcase_02.jpg'],
        ['tutorial/tutorial_mindWeather_01.jpg'],
        ['tutorial/tutorial_mindNote_01.jpg', 'tutorial/tutorial_mindNote_02.jpg'],
        ['tutorial/tutorial_guideChat_01.jpg', 'tutorial/tutorial_guideChat_02.jpg', 'tutorial/tutorial_guideChat_03.jpg', 'tutorial/tutorial_guideChat_04.jpg'],
      ]
    }
  },
  methods: {
    close() {
      this.model = 0;
      this.$emit('close');
    }
  }
}
</script>
<style lang="scss" scoped>
//::v-deep .v-dialog {
//  background: #fff;
//  border-radius: 0;
//
//  .v-carousel__controls {
//    top: 50px;
//    height: 7px;
//
//    .v-btn--icon.v-size--small {
//      width: 7px;
//      height: 7px;
//      border: 1px solid #fff;
//
//      .v-icon {
//        width: 7px;
//        height: 7px;
//
//        &:before {
//          content: '';
//        }
//      }
//    }
//
//    .v-btn--active.v-size--small {
//      background: #7260FF;
//      border: 1px solid #7260FF;
//
//      &:before {
//        opacity: 0;
//      }
//    }
//  }
//
//  .v-image__image--cover {
//    //background-size: 100% 100%;
//  }
//}
//
//.btn-close {
//  position: absolute;
//  width: 40px;
//  height: 40px;
//  left: 23px;
//  top: 33px;
//  z-index: 2;
//}
</style>
